exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-0ecd4952] {\n  margin-left: 10px;\n  margin-right: 10px;\n}", ""]);

// exports
